import React, { createContext, useContext, useState, ReactNode } from "react";

type AppSettingsContextType = {
  showWaffleIcon: boolean;
  setShowWaffleIcon: React.Dispatch<React.SetStateAction<boolean>>;
  renderAlternateMap: boolean;
  setRenderAlternateMap: React.Dispatch<React.SetStateAction<boolean>>;
  isDarkMode: boolean;
  setIsDarkMode: React.Dispatch<React.SetStateAction<boolean>>;
  showSatTrails: boolean;
  setShowSatTrails: React.Dispatch<React.SetStateAction<boolean>>;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const AppSettingsContext = createContext<AppSettingsContextType | undefined>(
  undefined,
);

export const AppSettingsProvider = ({ children }: { children: ReactNode }) => {
  const [showWaffleIcon, setShowWaffleIcon] = useState(true);
  const [renderAlternateMap, setRenderAlternateMap] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [showSatTrails, setShowSatTrails] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <AppSettingsContext.Provider
      value={{
        showWaffleIcon,
        setShowWaffleIcon,
        renderAlternateMap,
        setRenderAlternateMap,
        isDarkMode,
        setIsDarkMode,
        showSatTrails,
        setShowSatTrails,
        drawerOpen,
        setDrawerOpen,
      }}
    >
      {children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = (): AppSettingsContextType => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error(
      "useAppSettings must be used within an AppSettingsProvider",
    );
  }
  return context;
};
